import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { useState } from "react";

const NAV = [
  { label: "Home", href: "/" },
  { label: "Safaris", href: "/safaris" },
  { label: "Experiences", href: "/experiences" },
  { label: "Stays", href: "/stays" },
  { label: "Packages", href: "/packages" },
  { label: "Lookup", href: "/lookup" },
  { label: "Journal", href: "/blog" },
  { label: "About Jawai", href: "/about" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  if (pathname === "/admin") return null;
  return (
    <header className="sticky top-0 z-40 backdrop-blur-md bg-[#FAF7F2]/85 border-b border-[#E2DACF]">
      <div className="jt-container flex items-center justify-between py-4">
        <Link to="/" className="flex items-center" data-testid="header-logo-link">
          <img src="/logo-dark.png" alt="JawaiTrails.com" className="h-11 md:h-12 w-auto"/>
        </Link>
        <nav className="hidden md:flex items-center gap-8">
          {NAV.map((n) => (
            <Link
              key={n.href}
              to={n.href}
              data-testid={`nav-link-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={`text-sm tracking-wide ${pathname === n.href ? "text-[#1E3A2B] font-semibold" : "text-[#5C6B63] hover:text-[#1E3A2B]"}`}
            >
              {n.label}
            </Link>
          ))}
          <Link to="/book" className="jt-pill-accent text-sm" data-testid="header-book-cta">Book Safari</Link>
        </nav>
        <button className="md:hidden text-[#1E3A2B]" onClick={() => setOpen(!open)} data-testid="header-mobile-toggle" aria-label="Menu">
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>
      {open && (
        <div className="md:hidden border-t border-[#E2DACF] px-5 py-4 bg-[#FAF7F2]">
          {NAV.map((n) => (
            <Link key={n.href} to={n.href} onClick={() => setOpen(false)} className="block py-2 text-[#1C2421]" data-testid={`mobile-nav-${n.label.toLowerCase()}`}>{n.label}</Link>
          ))}
          <Link to="/book" onClick={() => setOpen(false)} className="jt-pill-accent mt-3 text-sm">Book Safari</Link>
        </div>
      )}
    </header>
  );
}
